import { render, staticRenderFns } from "./HaircutServices.vue?vue&type=template&id=66343b88"
import script from "./HaircutServices.vue?vue&type=script&lang=js"
export * from "./HaircutServices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports